import { Text, View } from "@react-pdf/renderer";
import { layoutStyles, textStyles } from ".";
import { normalizeArabic } from "@/v2/utils";

export default function PrintHeading({
    englishTitle,
    arabicTitle,
}: {
    englishTitle: string;
    arabicTitle: string;
}) {
    return (
        <View
            style={[
                layoutStyles.flexBetween,
                { fontWeight: 700, fontSize: "11px" },
            ]}
        >
            <Text
                style={{
                    color: "#ff9500",
                }}
            >
                {englishTitle}
            </Text>
            <Text></Text>
            <Text
                style={[
                    {
                        color: "#ff9500",
                    },
                    textStyles.arabicText,
                ]}
            >
                {normalizeArabic(arabicTitle)}
            </Text>
        </View>
    );
}
